let Bath = process.env.VUE_APP_BATH;
let API = process.env.VUE_APP_URL;
let WRITE = process.env.VUE_APP_AHEAD;
let CDNBOOK = process.env.VUE_APP_CDNBOOK;
let BENDI = process.env.VUE_APP_BENDI;
let AUTHOR = process.env.VUE_APP_AUTHOR;
let NOTICE = process.env.VUE_APP_NOTICE;
let CONSUME = process.env.VUE_APP_CONSUME;
let CDNCONSUME = process.env.VUE_APP_CDNCONSUME;
let SEARCH = process.env.VUE_APP_SEARCH;
// let WRITE = process.env.VUE_APP_WRITE;
export {
  Bath,
  API,
  BENDI,
  AUTHOR,
  WRITE,
  NOTICE,
  CONSUME,
  CDNCONSUME,
  CDNBOOK,
  SEARCH
};
